var _excluded = ["className", "size"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/index.css";
var Spinner = function Spinner(_ref) {
  var className = _ref.className,
    size = _ref.size,
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeClass = size ? styles["size-".concat(size)] : styles['size-default'];
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "".concat(styles.loading, " ").concat(sizeClass, " ").concat(className),
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    className: styles.spinner,
    cx: "50%",
    cy: "50%",
    r: "10",
    strokeDasharray: "0",
    strokeDashoffset: "0"
  }));
};
process.env.NODE_ENV !== "production" ? Spinner.propTypes = {
  /**
   * Additional classNames the consumer can pass
   */
  className: PropTypes.string,
  /**
   * A size class to set spinner height/width.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
} : void 0;
Spinner.defaultProps = {
  className: '',
  size: null
};
export default Spinner;